// The actual data fetching for this page lives in src/helpers/externalApiStats.js
// (shared with the "API analytics" tab on the client detail page), so this
// route carries no api1/onLoad action of its own - RouteComponent still
// expects an `api` object to be passed through, it is just empty here.
export default {};
